/** Browser vocabulary only; webMirrorContracts pins this block to the canonical core source. */
// mirror:reactions:start
export const REACTION_EMOJI = ['👍', '👎'] as const;
export type ReactionEmoji = typeof REACTION_EMOJI[number];
// mirror:reactions:end

/** The pressed state of each chip for the signed-in account. History and stream folds are shared by every
 *  member, so their `mine` is never this reader's: it is derived here from the chip's reactors and the
 *  authenticated account id. Answers the same array when nothing changes, so memoized rows stay put. */
export function reactionsForViewer<T extends { reactors: readonly { id: number | 'agent' }[]; mine: boolean }>(
  chips: readonly T[], viewerId: number,
): readonly T[] {
  const next = chips.map(chip => {
    const mine = chip.reactors.some(reactor => reactor.id === viewerId);
    return chip.mine === mine ? chip : { ...chip, mine };
  });
  return next.every((chip, index) => chip === chips[index]) ? chips : next;
}
